import { Box, Heading, Text, Image, Button } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePublishedItems } from '../../../hooks/useCourse';
import { useAssessmentToken } from '../../../context/AssessmentTokenContext';
import BottomTabApply from '../../assets/icons/BottomtabApply';
import BottomTabCreate from '../../assets/icons/BottomTabCreate';
import BottomTabPractice from '../../assets/icons/BottomTabPractice';
interface Props {
	isLocked?: boolean;
	isPrimary?: boolean;
	ctaText?: string;
	type?: string;
	courseId?: string;
	publishedItemId?: string;
	content: {
		[key: string]: any;
	};
	onCtaClick?: () => void;
}

const DashboardStepCard = ({ content, isLocked, isPrimary, ctaText, type, courseId, publishedItemId }: Props) => {
	const navigate = useNavigate();
	const { data: publishedItems, refetch: refetchPublishedItems } = usePublishedItems(courseId);
	const [roadmapPublishedItem, setRoadmapPublishedItem] = React.useState<any>();
	const { setSelectedRoadmapPublishedItemId } = useAssessmentToken();
	React.useEffect(() => {
		if (courseId) {
			refetchPublishedItems();
		}
	}, [courseId, refetchPublishedItems]);

	useEffect(() => {
		// filter first published item of type Roadmap
		if (!publishedItems) return;
		const roadmap = publishedItems.find(item => item.entityType === 'Roadmap');
		// @ts-ignore
		setRoadmapPublishedItem(roadmap);
		console.log('roadmap', roadmap);
	}, [publishedItems]);

	useEffect(() => {
		console.log('roadmapPublishedItem:', roadmapPublishedItem);
		if (roadmapPublishedItem?._id) {
			console.log('roadmapPublishedItem:', roadmapPublishedItem?._id);
			setSelectedRoadmapPublishedItemId(roadmapPublishedItem?._id);
		}
	}, [roadmapPublishedItem, setSelectedRoadmapPublishedItemId]);

	const renderSwitch = () => {
		switch (type) {
			case 'start-practice':
				return <BottomTabPractice boxSize={'33.231px'} />;
			case 'create-resume':
				return <BottomTabCreate boxSize={'33.231px'} />;
			case 'start-appying':
				return <BottomTabApply boxSize={'33.231px'} />;
			default:
				return <Image top="-1px" right="-1px" position={'absolute'} src="/images/icons/dashboard-step-icon-primary.svg" />;
		}
	};

	return (
		<Box overflow="hidden" position={'relative'} borderRadius={'16px'} p="16px" border="1px solid #E5E5E5" bgColor={'#F2F6FF'}>
			{
				isPrimary && !isLocked ? (
					<Box
						position="absolute"
						top="-5px"
						right="-5px"
						rounded="100px"
						h="54px"
						w="55.055px"
						bg={'#4358F6'}
						display="flex"
						alignItems="center"
						justifyContent="center"
						color={'#FFFFFF'}
						border="1px solid #D6E2FA"
						boxShadow="0px 4px 4px 0px #92B7FD1A"
					>
						{renderSwitch()}
					</Box>
				) : isLocked ? (
					<Box
						position="absolute"
						top="-5px"
						right="-5px"
						rounded="100px"
						h="54px"
						w="55.055px"
						bg={isLocked ? '#D6E2FA' : 'white'}
						display="flex"
						alignItems="center"
						justifyContent="center"
						color={isLocked ? '#FFFFFF' : '#4358F6'}
						border="1px solid #D6E2FA"
						boxShadow="0px 4px 4px 0px #92B7FD1A"
					>
						{renderSwitch()}
					</Box>
				) : (
					<Box
						position="absolute"
						top="-5px"
						right="-5px"
						rounded="100px"
						h="54px"
						w="55.055px"
						bg={isLocked ? '#D6E2FA' : 'white'}
						display="flex"
						alignItems="center"
						justifyContent="center"
						color={isLocked ? '#FFFFFF' : '#4358F6'}
						border="1px solid #D6E2FA"
						boxShadow="0px 4px 4px 0px #92B7FD1A"
					>
						{renderSwitch()}
					</Box>
				)
				// <Image top="-1px" right="-1px" position={'absolute'} src="/images/icons/dashboard-step-icon.svg" />
			}

			<Heading as="h6">{content?.header}</Heading>
			<Text color="#544D4F" textStyle={'body2'}>
				{content?.subheader}
			</Text>
			{!isLocked && (
				<Button
					mt="12px"
					variant={isPrimary ? 'primary' : 'secondary'}
					color={isPrimary ? 'white' : '#4358F6'}
					bgColor={isPrimary ? '#4358F6' : 'white'}
					onClick={() => {
						if (type === 'start-practice') {
							navigate(`/dashboard/published-item/${roadmapPublishedItem?._id}`);
						} else if (type === 'create-resume') {
							navigate('/resume');
						} else if (type === 'start-appying') {
							navigate('/apply');
						}
					}}
				>
					{content?.ctaText || 'Start'}
				</Button>
			)}
		</Box>
	);
};

export default DashboardStepCard;
